import { RouteComponentProps } from 'react-router';
import { compose } from 'recompose';

import withNavigation from '../hocs/withNavigation';
import PublicRouter, { AppProps } from './PublicRouter';

export default compose<AppProps, RouteComponentProps>(withNavigation)(PublicRouter);
